import {ErrorModel} from '../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../root';
const FUNCTION_CODE = 'GET_ALL_PRODUCTIONS';

export async function getAllProductions(
    userData: Record<string, string>,
    before: string,
    after: string,
    optionalProps?: Record<string, any>,
    query?: string
) {
    try {

        const response = await axios.get(
             
            `${URL}/productions/?before=${before}&after=${after}${optionalProps?.ressource ? `&ressource=${optionalProps.ressource}` : ""}${optionalProps?.deal ? `&deal=${optionalProps.deal}` : ""}&${query}`,
            {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Token ${userData.userToken}`
                }
            },
        );

        return response.data;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur de la récuperation d\'une production',
            error: error
        });
    }
}
